import { Box } from '@material-ui/core';
import { getMerchantStructureByMerchantId, User } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router-dom';

import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { SelectedUserStructure } from '@/components/shared/components/UserList/components/UserTable/components/UserTableBody/components/UserActionsRowDialog/components/ChangeUser/components/SelectedUserStructure';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';
import { UserInStructure } from '@/types/UserInStructure';

interface ChangeUserConfirmationDialogProps {
  onConfirmChange: () => void;
  confirmationDialogOpened: boolean;
  setConfirmationDialog: (boolean) => void;
  selectedUser: User;
  selectedDestination: UserInStructure;
  loading: boolean;
}

export const ChangeUserConfirmationDialog = ({
  onConfirmChange,
  confirmationDialogOpened,
  setConfirmationDialog,
  selectedUser,
  selectedDestination,
  loading,
}: ChangeUserConfirmationDialogProps) => {
  const { merchantId } = useParams();

  if (!merchantId) return null;

  const { data: merchantStructure } = useCache(getMerchantStructureByMerchantId, { merchantId });

  if (!merchantStructure) return null;

  return (
    <ActionDialog
      Title={<Text tId={'CONFIRM_CHANGE'} />}
      Description={<Text tId={'CONFIRM_CHANGE_TEXT'} dynamicDataTexts={[selectedUser.username]} />}
      MainButton={<Text tId={'CONFIRM_CHANGE_BTN'} />}
      onSubmit={onConfirmChange}
      opened={confirmationDialogOpened}
      setOpened={() => setConfirmationDialog(true)}
      handleClose={() => setConfirmationDialog(false)}
      loading={loading}
    >
      <Box mt={2} display={'flex'} flexDirection={'column'} alignItems={'center'}>
        <SelectedUserStructure selectedUser={selectedUser} merchantStructure={merchantStructure} />
        <Icon size={30}>arrow_downward</Icon>
        <SelectedUserStructure
          hideSelectedUser
          selectedUser={selectedDestination}
          merchantStructure={merchantStructure}
        />
      </Box>
    </ActionDialog>
  );
};
